export default __webpack_public_path__ + "static/media/fw-sophia-er-White Gold.c4de077b.mp4";